module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyBAMAAABYG2ONAAAAD1BMVEXZABKQEUIAM6CigjXyqABwofRbAAAAJklEQVR4AWNhIBmMXC2jWka1CJKnZTSQR7WMahnNYgOvZVTLqBYAVK0BDTB0dX0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/am.png
// module id = 49Nn
// module chunks = 0